import { render, staticRenderFns } from "./RpcTask.vue?vue&type=template&id=ef8d8b5e&scoped=true"
import script from "./RpcTask.vue?vue&type=script&lang=js"
export * from "./RpcTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8d8b5e",
  null
  
)

export default component.exports